import dayjs from 'dayjs';
import 'dayjs/locale/th';

dayjs.locale('th');

// แสดงวันที่/เวลาไทย พ.ศ.
export function fmtDateTime(iso: string | Date | null | undefined) {
  if (!iso) return '-';
  const d = dayjs(iso);
  return `${d.format('D MMM')} ${d.year() + 543} • ${d.format('HH:mm')}`;
}

export function fmtTime(iso: string | Date | null | undefined) {
  if (!iso) return '-';
  return dayjs(iso).format('HH:mm');
}

export function fmtDate(iso: string | Date | null | undefined) {
  if (!iso) return '-';
  const d = dayjs(iso);
  return `${d.format('D MMM')} ${d.year() + 543}`;
}

export function fmtDuration(minutes: number | null | undefined) {
  if (minutes == null) return '-';
  if (minutes < 1) return 'น้อยกว่า 1 นาที';
  if (minutes < 60) return `${minutes} นาที`;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m === 0 ? `${h} ชม.` : `${h} ชม. ${m} นาที`;
}

export function durationFromNow(start: string | Date) {
  const ms = Date.now() - new Date(start).getTime();
  const minutes = Math.floor(ms / 60000);
  return fmtDuration(minutes);
}
